export default [
  {
    path: '/crazyrope/battle',
    name: 'crazyrope_battle',
    props: (route: any) => ({ ...route.query, ...route.params }),
    component: () => import('../../views/battle/Index.vue'),
  },
]
